import React, { useState, useEffect } from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import { useNavigate } from "react-router-dom";
import { FormTypeAdd, FormTypeEdit } from "utils/Constant";
import { useModal } from "context/ModalContext";
import { useCallApi } from "api/apiHooks";
import { FormCard, MainBodyCard, PagesTitle } from "components/Cards";

export default function CategoryForm(){
    let navigate = useNavigate()
    
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchUpdateCategory, fetchCategoryById, fetchCreateCategory } = useCallApi()
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let categoryId = queryString.get("categoryId")

    const [categoryName, setCategoryName] = useState('')
    
    // Button Event
    const saveBtnClick = async () => {
        if(!validation()) return

        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            if (formType === FormTypeAdd) {
                const res = await fetchCreateCategory(categoryName)
                if (!res) return
            } else {
                const res = await fetchUpdateCategory(categoryId, categoryName)
                if (!res) return 
            }

            showSuccess({
                onSuccess: () => {
                    navigate("/category") 
                }
            })            
        }
        finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    // Function
    const validation = () => {
        if (categoryName === null) {
            showFail('Category Name is required!')
            return false
        }

        return true
    }
    
    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                // If Form Type Edit then get data
                if (formType === FormTypeEdit) {
                    const res = await fetchCategoryById(categoryId)
                    if (!res) return

                    let data = res.data

                    // Data
                    setCategoryName(data.categoryName)
                }
            }
            finally {
                hideLoading()
            }
        }

        onLoad()        
    }, [])

    return(
        <MainBodyCard>
            <div>
                <PagesTitle title='Category Detail' />

                <div className="mt-5 flex flex-col gap-3 ">
                    {/* Category Name */}
                    <FormCard title='Category Name'>
                        <input className="input" value={categoryName} onChange={(e) => { setCategoryName(e.target.value) }} maxLength={20} />
                    </FormCard>
                </div>
            </div>            

            {/* Button */}
            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <BackButton onClick={backBtnClick} />
            </div>
        </MainBodyCard>        
    )
}
